import React, { useState, useEffect, useRef } from "react";
import { interpolate } from "flubber";

import { motion, useAnimation } from "framer-motion";
const ArrowMorph = ({
  className = "",
  isDarkMode = false,
  isHovered = false,
}) => {
  const [midPath, setMidPath] = useState("M103.5 1.5 L103.5 1.51");
  const [leftPath, setLeftPath] = useState("M103.5 1.5 L103.5 1.51");
  const [rightPath, setRightPath] = useState("M103.5 1.5 L103.5 1.51");

  const [hasInteracted, setHasInteracted] = useState(false);
  const hoverRef = useRef(false); // 保持是否仍在 hover 的信息

  const centerY = 128.5;

  const midStart = `M103.5 ${centerY} L103.5 ${centerY}`;
  //const midEnd = "M103.5 1 V190";

  const leftStart = `M103.5 ${centerY} L103.5 ${centerY}`;
  //const leftEnd = "M103.5 1 L20 110";

  const rightStart = `M103.5 ${centerY} L103.5 ${centerY}`;
  //const rightEnd = "M103.5 1 L187 110";

  const offsetY = 35;

  const midEnd = `M103.5 ${offsetY} V${190 + offsetY}`;
  const leftEnd = `M103.5 ${offsetY} L20 ${110 + offsetY}`;
  const rightEnd = `M103.5 ${offsetY} L187 ${110 + offsetY}`;

  // 动态
  const [startFloating, setStartFloating] = useState(false);

  useEffect(() => {
    const totalFrames = 30;
    let frame = 0;

    const midInterp = interpolate(
      isHovered ? midStart : midEnd,
      isHovered ? midEnd : midStart
    );
    const leftInterp = interpolate(
      isHovered ? leftStart : leftEnd,
      isHovered ? leftEnd : leftStart
    );
    const rightInterp = interpolate(
      isHovered ? rightStart : rightEnd,
      isHovered ? rightEnd : rightStart
    );

    const interval = setInterval(() => {
      const t = frame / totalFrames;
      setMidPath(midInterp(t));
      setLeftPath(leftInterp(t));
      setRightPath(rightInterp(t));
      frame++;
      if (frame > totalFrames) {
        clearInterval(interval);

        // ✅ 修改这里：只要 hover 状态仍在就触发浮动
        if (hoverRef.current) {
          setStartFloating(true);
        }
      }
    }, 1000 / 60);

    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <motion.svg
      viewBox="0 0 207 257"
      width="51.75"
      height="64.25"
      fill="none"
      stroke={isDarkMode ? "white" : "black"}
      strokeWidth="30"
      strokeLinecap="round"
      strokeLinejoin="round"
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
      className={`transition duration-300 ${className}`}
      onMouseEnter={() => {
        hoverRef.current = isHovered;
      }}
      onMouseLeave={() => {
        hoverRef.current = isHovered;
      }}
    >
      <motion.path d={midPath} />
      <motion.path d={leftPath} />
      <motion.path d={rightPath} />
    </motion.svg>
  );
};

export default ArrowMorph;
